export const normalizePathname = (pathname) =>
    pathname ? `${pathname}/`.replace(/\/+/g, '/') : null
